"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiversitySupport = void 0;
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var DiversitySupport = (function (_super) {
    __extends(DiversitySupport, _super);
    function DiversitySupport() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DIVERSITY_SUPPORT,
            tags: [],
            cost: 1,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.resourceTypes(9); }),
            metadata: {
                cardNumber: 'X20',
                description: 'Requires that you have 9 different types of resources. Gain 1 TR.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.tr(1); }),
            },
        }) || this;
    }
    DiversitySupport.prototype.play = function (player) {
        player.increaseTerraformRating();
        return undefined;
    };
    return DiversitySupport;
}(Card_1.Card));
exports.DiversitySupport = DiversitySupport;
//# sourceMappingURL=DiversitySupport.js.map